var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: {
        title: "获取我的行程单",
        visible: _vm.showItinerary,
        "append-to-body": "",
        width: "30%",
      },
      on: { close: _vm.closeDialog },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "el-button",
                {
                  staticStyle: { width: "100%" },
                  attrs: { type: "primary", loading: _vm.saveLoading },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("\n      获取\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-form",
        {
          ref: "formName",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.ruleForm, rules: _vm.rules, "label-width": "0" },
        },
        [
          _c(
            "div",
            {
              staticClass: "font-14 color-333",
              staticStyle: { "font-weight": "700" },
            },
            [_vm._v(_vm._s(_vm.itineraryInfo.time || ""))]
          ),
          _c("div", { staticClass: "font-12 color-666 margin-top-10" }, [
            _vm._v(
              _vm._s(
                _vm.isPick
                  ? _vm.itineraryInfo.ferryStartAddress
                  : _vm.itineraryInfo.departureStationAddress
              ) +
                " ——\n      " +
                _vm._s(
                  _vm.isSend
                    ? _vm.itineraryInfo.ferryEndAddress
                    : _vm.itineraryInfo.destinationStationAddress
                )
            ),
          ]),
          _c("el-divider"),
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.itineraryValue,
                callback: function ($$v) {
                  _vm.itineraryValue = $$v
                },
                expression: "itineraryValue",
              },
            },
            _vm._l(
              _vm.itineraryInfo.ticketAndFerryFOrderVos,
              function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "margin-bottom-7" },
                  [
                    _c("el-checkbox", { attrs: { label: item.id } }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-align-center flex-justify-between",
                          staticStyle: { width: "100%" },
                        },
                        [
                          _c("div", { staticClass: "color-000" }, [
                            _vm._v(_vm._s(item.label)),
                          ]),
                          _c("div", { staticClass: "color-redFont" }, [
                            _vm._v("￥" + _vm._s(item.amount)),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  1
                )
              }
            ),
            0
          ),
          _c(
            "div",
            { staticClass: "flex flex-align-center flex-justify-end" },
            [
              _vm._v("\n      合计金额："),
              _c("div", { staticClass: "color-redFont" }, [
                _vm._v("￥" + _vm._s(_vm.priceTotal.toFixed(2) || 0.0)),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            { staticClass: "margin-top-15", attrs: { prop: "email" } },
            [
              _c("el-input", {
                staticStyle: {
                  width: "100%",
                  background: "#f6f6f6",
                  "border-radius": "10px",
                },
                attrs: { placeholder: "在此输入您的电子邮箱（必填）" },
                model: {
                  value: _vm.ruleForm.email,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.ruleForm,
                      "email",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "ruleForm.email",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }